import { InboxOutlined } from "@ant-design/icons";
import { Select } from "antd";
import Dragger from "antd/es/upload/Dragger";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import defaultPreview from "../../assets/img/Excel-logo.png";
import Footer from "../../components/Footer";
import NavBar from "../../components/NavBar";
import SideBar from "../../components/SideBar";
import axiosInstance from "../../variables/api/axiosInstance";
import axiosMultiPartDataInstance from "../../variables/api/axiosMultiPartDatainstance";
import "./MigrationProduction.css";

const MigrationProduction = () => {
    const [loading, setLoading] = useState(false);
    const [loadingPool, setLoadingPool] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [compagnies, setCompagnies] = useState([]);
    const [selectedCompagnie, setSelectedCompagnie] = useState("");
    const [fichier, setFichier] = useState("");

    const handlePreview = (file) => {
        console.log("file: ", file);
        this.setState({
            previewImage: defaultPreview,
            previewVisible: true,
        });
    };

    useEffect(() => {
        axiosInstance
            .get(`/api/organisme/assurance`)
            .then((res) => {
                setCompagnies(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const onSelectChange = (newSelectedRowKeys, rows) => {
        console.log("selectedRowKeys changed: ", newSelectedRowKeys);
        console.log("SelectedRows", rows);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        columnWidth: 2,
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const navigate = useNavigate();

    const onSubmit = (e) => {
        setLoading(true);
        e.preventDefault();
        // console.log("submit");
        if (selectedCompagnie) {
            const formData = new FormData();
            formData.append("fichier", fichier.originFileObj);
            formData.append("compagnie", selectedCompagnie.code);
            axiosMultiPartDataInstance.post('/api/migration/production', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(res => {
                console.log(res);
            }).catch(err => {
                console.log(err);
            })

            toast(`Compagnie - ${selectedCompagnie.code}`);
            setLoading(false);
        } else {
            toast("Compagnie non sélectionnée");
            setLoading(false);
        }
    };


    const onSubmitPool = (e) => {
        setLoadingPool(true);
        e.preventDefault();
        // console.log("submit");

        const formData = new FormData();
        formData.append("fichier", fichier.originFileObj);
        axiosMultiPartDataInstance.post('/api/migration/pool-production', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => {
            console.log(res);
            setLoadingPool(false);
        }).catch(err => {
            console.log(err);
            setLoadingPool(false);
        })

    };

    const onSubmitPoolRenouvellement = (e) => {
        setLoadingPool(true);
        e.preventDefault();
        // console.log("submit");

        const formData = new FormData();
        formData.append("fichier", fichier.originFileObj);
        axiosMultiPartDataInstance.post('/api/migration/pool-production-renouvellement', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => {
            console.log(res);
            setLoadingPool(false);
        }).catch(err => {
            console.log(err);
            setLoadingPool(false);
        })

    };



    const uploadSubmit = (e) => {
        e.fileList.forEach((file) => {
            console.log("File: ", file);
            setFichier(file);
            //      const reader = new FileReader();
            //
            //      reader.onload = (event) => {
            //        const csvContent = event.target.result; // CSV content
            //        // Process the CSV content
            //        processCSVContent(csvContent);
            //      };
            //
            //      reader.readAsText(file.originFileObj);
        });
    };

    const removeFile = (e) => {
        console.log("removeFile: ", e);
    };

    const compagnieFiltering = (code, comp) => {
        setSelectedCompagnie(comp.data);
    }

    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <SideBar currentMenu={"PRODUCTION"} />

                {/* <!-- Layout container --> */}
                <div className="layout-page">
                    <NavBar />

                    {/* <!-- Content wrapper --> */}
                    <div className="content-wrapper">
                        {/* <!-- Content --> */}
                        <div className="container-xxl flex-grow-1 container-p-y migration-container">

                            {/* Section 1: Bordereaux d'émission */}
                            <form onSubmit={onSubmit}>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="card migration-card shadow-sm">
                                                <div className="card-header migration-card-header">
                                                    <div className="card-text">
                                                        <h4 className="text-white mb-0 d-flex align-items-center">
                                                            <i className="bi bi-file-earmark-arrow-up me-2"></i>
                                                            Charger les bordereaux d'émission
                                                        </h4>
                                                    </div>
                                                </div>

                                                <div className="card-body p-4">
                                                    <div className="row">
                                                        <div className="col-12 mb-4">
                                                            <label className="form-label fw-semibold" htmlFor="exercice">
                                                                <i className="bi bi-building me-2"></i>
                                                                Compagnie
                                                            </label>
                                                            <Select
                                                                placeholder="Sélectionner la compagnie"
                                                                size="large"
                                                                style={{
                                                                    width: '100%',
                                                                }}
                                                                onChange={compagnieFiltering}
                                                                options={compagnies.map((com) => ({
                                                                    value: com.code,
                                                                    label: com.raisonSociale,
                                                                    data: com
                                                                }))}
                                                            />
                                                        </div>
                                                        <div className="col-12">
                                                            {/* <!-- Dragger Section for File Upload --> */}
                                                            <div className="upload-zone">
                                                                <Dragger
                                                                    onChange={(e) => uploadSubmit(e)}
                                                                    beforeUpload={() => false}
                                                                    onRemove={(e) => removeFile(e)}
                                                                    accept={".xlsx,.csv, .xls"}
                                                                    onPreview={handlePreview}
                                                                    maxCount={1}
                                                                    className="custom-dragger"
                                                                >
                                                                    <p className="ant-upload-drag-icon">
                                                                        <InboxOutlined style={{ fontSize: '48px', color: '#1890ff' }} />
                                                                    </p>
                                                                    <p className="ant-upload-text fw-semibold">
                                                                        Cliquez ou faites glisser le fichier dans cette zone
                                                                    </p>
                                                                    <p className="ant-upload-hint text-muted">
                                                                        Formats acceptés: .xlsx, .csv, .xls
                                                                    </p>
                                                                </Dragger>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="card-footer bg-light d-flex justify-content-center py-3">
                                                    <button
                                                        className="btn btn-primary btn-lg px-5 shadow-sm"
                                                        disabled={loading}
                                                        onClick={(e) => onSubmit(e)}
                                                    >
                                                        {loading && (
                                                            <span
                                                                className="spinner-grow spinner-grow-sm me-2"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                        )}
                                                        {loading ? `Enregistrement en cours...` : `Enregistrer`}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            {/* Section 2: Polices sinistrées POOL */}
                            <div className="container mt-4">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card migration-card shadow-sm">
                                            <div className="card-header migration-card-header-secondary">
                                                <div className="card-text">
                                                    <h4 className="text-white mb-0 d-flex align-items-center">
                                                        <i className="bi bi-database-fill-up me-2"></i>
                                                        Reprise de données Polices sinistrées POOL
                                                    </h4>
                                                </div>
                                            </div>

                                            <div className="card-body p-4">
                                                <div className="row">
                                                    <div className="col-12">
                                                        {/* <!-- Dragger Section for File Upload --> */}
                                                        <div className="upload-zone">
                                                            <Dragger
                                                                onChange={(e) => uploadSubmit(e)}
                                                                beforeUpload={() => false}
                                                                onRemove={(e) => removeFile(e)}
                                                                accept={".xlsx,.csv, .xls"}
                                                                onPreview={handlePreview}
                                                                maxCount={1}
                                                                className="custom-dragger"
                                                            >
                                                                <p className="ant-upload-drag-icon">
                                                                    <InboxOutlined style={{ fontSize: '48px', color: '#52c41a' }} />
                                                                </p>
                                                                <p className="ant-upload-text fw-semibold">
                                                                    Cliquez ou faites glisser le fichier dans cette zone
                                                                </p>
                                                                <p className="ant-upload-hint text-muted">
                                                                    Formats acceptés: .xlsx, .csv, .xls
                                                                </p>
                                                            </Dragger>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card-footer bg-light d-flex justify-content-center py-3">
                                                <button
                                                    className="btn btn-success btn-lg px-5 shadow-sm"
                                                    disabled={loadingPool}
                                                    onClick={(e) => onSubmitPool(e)}
                                                >
                                                    {loadingPool && (
                                                        <span
                                                            className="spinner-grow spinner-grow-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                    )}
                                                    {loadingPool ? `Enregistrement en cours...` : `Enregistrer`}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Section 3: Contrats motos POOL */}
                            <div className="container mt-4">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card migration-card shadow-sm">
                                            <div className="card-header migration-card-header-tertiary">
                                                <div className="card-text">
                                                    <h4 className="text-white mb-0 d-flex align-items-center">
                                                        <i className="bi bi-arrow-repeat me-2"></i>
                                                        Reprise des contrats motos renouvélées au POOL TPVM-VT GIE
                                                    </h4>
                                                </div>
                                            </div>

                                            <div className="card-body p-4">
                                                <div className="row">
                                                    <div className="col-12">
                                                        {/* <!-- Dragger Section for File Upload --> */}
                                                        <div className="upload-zone">
                                                            <Dragger
                                                                onChange={(e) => uploadSubmit(e)}
                                                                beforeUpload={() => false}
                                                                onRemove={(e) => removeFile(e)}
                                                                accept={".xlsx,.csv, .xls"}
                                                                onPreview={handlePreview}
                                                                maxCount={1}
                                                                className="custom-dragger"
                                                            >
                                                                <p className="ant-upload-drag-icon">
                                                                    <InboxOutlined style={{ fontSize: '48px', color: '#fa8c16' }} />
                                                                </p>
                                                                <p className="ant-upload-text fw-semibold">
                                                                    Cliquez ou faites glisser le fichier dans cette zone
                                                                </p>
                                                                <p className="ant-upload-hint text-muted">
                                                                    Formats acceptés: .xlsx, .csv, .xls
                                                                </p>
                                                            </Dragger>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card-footer bg-light d-flex justify-content-center py-3">
                                                <button
                                                    className="btn btn-warning btn-lg px-5 shadow-sm"
                                                    disabled={loadingPool}
                                                    onClick={(e) => onSubmitPoolRenouvellement(e)}
                                                >
                                                    {loadingPool && (
                                                        <span
                                                            className="spinner-grow spinner-grow-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                    )}
                                                    {loadingPool ? `Enregistrement en cours...` : `Enregistrer`}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div className="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>

            {/* <!-- Overlay --> */}
            <div className="layout-overlay layout-menu-toggle"></div>

            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div className="drag-target"></div>
        </div>
    );
};

export default MigrationProduction;